import { ResponseModel } from './response.model';

export const CERT_OTHER_ID = 999999;
export const CERT_OTHER_NAME = 'Other';

export interface Reimbursement extends ResponseModel {
    educationReimbursements: EducationReimbursement[];
    stateLicensureReimbursements: StateLicensureReimbursement[];
}

export interface EducationReimbursement {
    id: number;
    name: string;
    amount: number;
}

export interface StateLicensureReimbursement {
    id: number;
    name: string;
    code: string;
    initialCost: number;
    /** Updated cost of the reimbursement. Changed from the initial value.  */
    updatedCost?: number;
}

export interface ReimbursementListItem {
    id: number;
    name: string;
    amount: number;
    code: string;
    initialCost: number;
    originalCost: number;
    selected: boolean;
}
